import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'pt-validator-permission-help',
  template: `
    <div>
      <span><b>{{'USER_PERMISSIONS.VALIDATOR.INTRODUCTION' | translate}}:</b></span>
      <ul class="m-0">
        <li>{{'USER_PERMISSIONS.VALIDATOR.CAN_READ_ALL' | translate}}</li>
        <li>{{'USER_PERMISSIONS.VALIDATOR.CAN_VALIDATE_DOCUMENTS' | translate}}</li>
      </ul>
    </div>
  `
})
export class ValidatorPermissionHelpComponent {
  constructor(public translate: TranslateService) {
  }
}
